// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { colors, transition, fontWeights } from 'theme';

const RadioButton = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  appearance: none;
  outline: 0;
  border: 0;
  margin: 0;
  background: white;
  box-shadow: 0 0 0 1px ${colors.silver} inset;
  color: ${colors.greyishBrown};
  transition: all ${transition};

  &:checked {
    background: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue} inset;

    & + label {
      color: white;
    }
  }

  &:not(:checked):hover {
    background: ${colors.aluminum};
    cursor: pointer;
  }
`;

const RadioContainer = styled(Box)`
  height: 50px;

  ${props =>
    props.$checked &&
    `
  z-index: 1;
  `}

  &:first-child {
    ${RadioButton} {
      border-radius: 4px 0 0 4px;
    }
  }

  &:last-child {
    ${RadioButton} {
      border-radius: 0 4px 4px 0;
    }
  }

  &:not(:first-child) {
    width: calc(100% + 2px);
    margin-left: -1px;
  }

  label {
    position: relative;
    font-size: 16px;
    font-weight: ${fontWeights.semiBold};
    transition: all ${transition};
    pointer-events: none;
  }
`;

const RadioToggle = ({
  buttons,
  value,
  name,
  onChange,
  ...props
}: {
  buttons: Array<{ label: string, value: string }>,
  value: ?mixed,
  name: string,
  onChange: Function
}) => (
  <Box data-qa-id={name} width={1} display="flex">
    {buttons.map(button => (
      <RadioContainer
        position="relative"
        flex="1"
        display="flex"
        alignItems="center"
        justifyContent="center"
        data-qa-id={`${name}-${button.value}`}
        $checked={value === button.value}
      >
        <RadioButton
          type="radio"
          name={name}
          value={value}
          checked={value === button.value}
          id={`${name}-${button.value}`}
          onChange={() => onChange(button.value)}
          {...props}
        />

        <label htmlFor={`${name}-${button.value}`}>{button.label}</label>
      </RadioContainer>
    ))}
  </Box>
);

export default RadioToggle;
